export default {
  home: 'Inicio',
  menu: 'Menú',
  orders: 'Pedidos',
};
